<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="options"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      :placeholder="placeholder"
      @input="onInput"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="state.loading"
          :style="{ opacity: state.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay divisiones para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('Usuario', [
      'currentUserId'
    ]),
    ...mapGetters('List', {
      state: 'companyDivisionsState'
    }),
    optionSelected() {
      return this.state.list.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled
        || !this.state.list.length
        || this.state.loading;
    },
    options() {
      if (this.onlygroup) {
        return this.state.list.filter((option) => option.esOficina !== 'Y');
      }
      return this.state.list;
    }
  },
  methods: {
    ...mapActions('List', {
      fetch: 'fetchCompanyDivisions'
    }),
    onInput(event) {
      this.$emit('input', event?.value);
    },
    getOption() {
      return this.state.list.find((option) => option.value === this.value);
    }
  },
  created() {
    this.fetch();
  },
  props: {
    onlygroup: { type: Boolean, default: false },
    name: { type: String, required: true },
    placeholder: String,
    autocomplete: { type: Boolean, default: false },
    label: { type: String, default: 'Divisiones' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false }
  }
};

</script>
